import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsAddonsOauthRoute: InvariantJiraRoute = {
	name: 'global-settings-addons-oauth',
	path: '/secure/oauth-credentials',
};
